module.exports = __webpack_public_path__ + "static/media/kushner-sm.55c0222d.png";